import { render, staticRenderFns } from "./fieldsSort.vue?vue&type=template&id=12b87413&scoped=true&"
import script from "./fieldsSort.vue?vue&type=script&lang=ts&"
export * from "./fieldsSort.vue?vue&type=script&lang=ts&"
import style0 from "./fieldsSort.vue?vue&type=style&index=0&id=12b87413&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b87413",
  null
  
)

export default component.exports